<template>
    <div class="voteListInfo">
        <bv-top></bv-top>
        <div v-for="(item,index) in voteListInfo" :key="index">
            <van-cell-group title="项目详情信息">
                <van-cell title="项目名称" :value="item.name" />
                <van-cell title="分摊方式" :value="item.way" />
                <van-cell title="总面积" :value="item.area" />
                <van-cell title="总户数" :value="item.houseHold" />
                <van-cell title="未表决户数" :value="item.onVoteHold" />
                <van-cell title="表决标准" value="内容" />
            </van-cell-group>
            <van-cell-group title="个人分摊详情">
                <van-cell title="业主分摊" :value="item.owner" />
                <van-cell title="可用余额" :value="item.balance" />
                <van-cell title="账户支付" :value="item.pay" />
                <van-cell title="现金自付" :value="item.priority" />
                <van-cell title="房屋面积" :value="item.house" />
            </van-cell-group>
            <van-cell-group title="请选择表决结果">
                <van-row type="flex">
                    <van-col span="24">
                        <van-radio-group v-model="radio">
                            <van-cell-group>
                                <van-cell title="同意" clickable @click="radio = '1'">
                                    <van-radio slot="right-icon" name="1" checked-color="#2acba2" />
                                </van-cell>
                                <van-cell title="不同意" clickable @click="radio = '2'">
                                    <van-radio slot="right-icon" name="2" checked-color="#2acba2" />
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                    </van-col>
                </van-row>
            </van-cell-group>
            <van-row type="flex" justify="center">
                <van-col span="22">
                    <van-button type="primary" size="large" class="footBut">表决</van-button>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    export default {
        name: "VoteListInfo",
        data(){
            return{
                radio: '1',
                voteListInfo:[
                    {
                        name:'测试',
                        way:'自定义分摊',
                        area:'12445.04㎡',
                        houseHold:'57（户）',
                        onVoteHold:'57（户）',
                        owner:'34.46（元）',
                        balance:'5570.9（元）',
                        pay:'34.46（元）',
                        priority:'0（元）',
                        house:'214.4（㎡）'
                    }
                ]
            }
        },
        components:{
            BvTop:Top
        }
    }
</script>

<style lang='scss' scoped>
    .voteListInfo{
        background: #f2f2f2;
        .footBut{
            margin: 5% 0;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }
        .van-cell-group__title {
            padding: 10px 16px !important;
            background: #f2f2f2 !important;
        }
    }
</style>